import React from 'react';

export function initials(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return (parts[0][0] + (parts[1]?.[0] ?? '')).toUpperCase();
}

// Initials in a soft blue disc, the same one the Hygiene queue uses.
export default function Avatar({ name, size = 'md' }: { name: string | null | undefined; size?: 'sm' | 'md' }) {
  const dims = size === 'sm' ? 'h-6 w-6 text-[0.6875rem]' : 'h-8 w-8 text-[0.6875rem]';
  return (
    <span
      role="img"
      aria-label={name ?? 'Unassigned'}
      title={name ?? 'Unassigned'}
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-blue-50 font-semibold text-blue-700 ring-1 ring-inset ring-blue-200 ${dims}`}
    >
      {initials(name)}
    </span>
  );
}
